import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import axios from "axios";

import BarraAreaAlunoConteudos from "../../../components/BarraAreaAlunoConteudos/BarraAreaAlunoConteudos";
import Modulos from "./components/Modulos/Modulos";

import styles from "./Conteudos.module.scss";

export default function Conteudos() {
    const { id: turmaId } = useParams();

    const [disciplinas, setDisciplinas] = useState([]);
    const [codigoCurso, setCodigoCurso] = useState("");
    const [nomeDisciplina, setNomeDisciplina] = useState("");

    const location = useLocation();

    const listarDisciplinas = () => {
        const codeNumber = Number(atob(turmaId));

        axios({
            method: "get",
            url: `/api/gestao-turmas/listar-disciplinas?turmaId=${codeNumber}&perfilId=1`
        })
            .then(response => {
                setDisciplinas(response.data);
                const disciplina = response.data[0];

                const codigoCursoStorage = localStorage.getItem("codigo_curso");

                const codigoCurso = codigoCursoStorage ? Number(codigoCursoStorage) : disciplina.id;

                setCodigoCurso(codigoCurso);

                if (!codigoCursoStorage) {
                    localStorage.setItem("codigo_curso", String(disciplina.id));
                }

                var nomeDisciplina = response.data.find(d => d.id === codigoCurso).nome;

                setNomeDisciplina(nomeDisciplina);
            })
            .catch(error => {

            });
    };

    useEffect(() => {
        localStorage.setItem("player_back_url", location.pathname);

        listarDisciplinas();
    }, []);

    return (
        <div className={styles.conteudos}>
            <div className="background-layer" />
            <div className="titulo">
                <h1> ÁREA DO ALUNO</h1>
            </div>

            <BarraAreaAlunoConteudos
                disciplinas={disciplinas}
                codigoCurso={codigoCurso}
                onChangeDisciplina={(id, nome) => {
                    setCodigoCurso(id);
                    setNomeDisciplina(nome);
                    localStorage.setItem("codigo_curso", id);
                }}
                code={turmaId}
            />

            {codigoCurso && <Modulos cursoid={codigoCurso} nomeDisciplina={nomeDisciplina} />}
        </div>
    );
}
